(function() {
  var SCROLL_THRESHOLD = 80;
  var header = null;
  var ticking = false;

  function updateHeader() {
    if (!header) header = document.querySelector('m-header');
    if (!header) return;
    if (window.scrollY > SCROLL_THRESHOLD) {
      header.classList.add('tentello-scrolled');
    } else {
      header.classList.remove('tentello-scrolled');
    }
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        updateHeader();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeader);
  } else {
    updateHeader();
  }
})();